import React from "react";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const columns = [
  ["family", "Famiglia"], ["thickness_mm", "Spessore · mm"], ["cava", "Cava completa"],
  ["deduction_mm", "Ritiro · mm"], ["notes", "Note"],
];

export const DeductionRows = ({ rows, editable, onChange, onRemove }) => (
  <div className="opaque-editable-fields min-w-0" data-testid="deduction-rows">
    {!rows.length && <p className="py-8 text-sm text-muted-foreground border-y" data-testid="deduction-empty">Nessun ritiro configurato per questo account.</p>}
    {rows.map((row, index) => <div key={row.id} data-testid={`deduction-row-${row.id}`} className="grid grid-cols-2 xl:grid-cols-[1fr_1fr_1fr_1fr_2fr_auto] items-end gap-3 border-b py-4">
      {columns.map(([key, label]) => <div className={`min-w-0 ${key === "notes" ? "col-span-2 xl:col-span-1" : ""}`} key={key}>
        <Label className="text-xs" htmlFor={`deduction-${row.id}-${key}`}>{label}</Label>
        <Input id={`deduction-${row.id}-${key}`} data-testid={`deduction-${row.id}-${key.replaceAll("_", "-")}`}
          className={key === "notes" || key === "family" ? "" : "font-mono"} type={["notes", "family", "cava"].includes(key) ? "text" : "number"}
          min={key === "deduction_mm" ? "0" : "0.000001"} step="any" maxLength={key === "notes" ? 1000 : key === "family" ? 60 : undefined}
          required={!["notes", "family"].includes(key)} value={row[key] ?? (key === "cava" ? row.v_opening_mm : "")} placeholder={key === "family" ? "Generico precedente" : key === "cava" ? "16 · 20/60°" : undefined} disabled={!editable}
          onChange={e => onChange(row.id, key, e.target.value)} />
      </div>)}
      {editable && <Button type="button" size="icon" variant="ghost" title={`Elimina riga ${index + 1}`} aria-label={`Elimina riga ${index + 1}`}
        data-testid={`deduction-delete-${row.id}`} onClick={() => onRemove(row.id)} className="text-destructive justify-self-end"><Trash2 size={16} /></Button>}
    </div>)}
  </div>
);